//@ts-nocheck
import { PhoneIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field, Formik } from "formik";
import { observer } from "mobx-react-lite";
import { object, string } from "yup";
import FlagPhoneInput from "../../../components/form-elements/FlagPhoneInput";
import Select from "../../../components/form-elements/Select";
import CTAButtons from "./CTAButtons";

const supportedTitles = [
  "Mr.",
  "Mrs.",
  "Ms.",
  "Dr.",
  "Engr.",
  "Chief",
  "Barr.",
  "Alh.",
  "HRH",
  "Prof.",
  "Capt.",
  "Hon.",
  "Sen.",
  "Amb.",
  "Pst.",
  "Rev",
  "Arch.",
];

const mediums = [
  "Facebook",
  "Instagram",
  "Searched online",
  "From a friend",
  "From a teacher",
  "LinkedIn",
  "Twitter",
  "Nairaland",
  "YouTube",
  "From a blog",
  "Watched on TV",
  "Heard on Radio",
  "Got an SMS",
  "At an event",
  "Physical banner",
  "Website banner",
  "Other media",
];

const validationSchema = object().shape({
  title: string().trim().required("Select title"),
  firstName: string().trim().required("Enter firstname"),
  lastName: string().trim().required("Enter lastname"),
  email: string()
    .email("Enter a valid email")
    .required("Enter an active email"),
  phone: string().required("Phone is required"),
  preferredComms: object().shape({
    number: string(),
    channel: string(),
  }),
  medium: string().required("Select medium"),
});

let placeholders = {
  title: {
    label: "Title",
    placeholder: "Select",
  },
  firstName: {
    label: "First name",
    placeholder: "Your first name",
  },
  lastName: {
    label: "Last name",
    placeholder: "Your last name",
  },
  email: {
    label: "Email address",
    placeholder: "Your email",
  },
  phone: {
    label: "Phone number",
    placeholder: "Your phone number",
  },
  preferredComms: {
    label: "WhatsApp (recommended)",
    placeholder: "Put country code e.g 23470...",
  },
  medium: {
    label: "How did you hear about us?",
    placeholder: "Select medium",
  },
};

let commonProps = ({ name }, { touched, errors }) => ({
  ...placeholders[name],
  isInvalid: Boolean(touched[name] && errors[name]),
  errorMessage: errors[name],
  size: "lg",
  fontSize: "md",
});

const titleOptions = supportedTitles.map((title) => ({
  label: title,
  value: title,
}));

const mediumOptions = mediums.map((medium) => ({
  label: medium,
  value: medium,
}));

function ParentForm({
  onSubmit = () => {},
  viewModel,
  value = {},
  spacing = "20px",
  countryName = "Nigeria",
  countryCode = "NG",
  loading = false,
  loadingText,
  onBackClick,
  ...rest
}) {
  return (
    <Formik
      key={`${viewModel.phone} ${viewModel.loading}`}
      validationSchema={validationSchema}
      initialValues={viewModel.toJSON()}
      onSubmit={onSubmit}
    >
      {({ handleSubmit }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Stack spacing={spacing}>
              <Flex direction={["column", "row"]}>
                <Field name="title">
                  {({ field, form }) => (
                    <FormControl
                      width={["100%", "25%"]}
                      isInvalid={commonProps(field, form).isInvalid}
                    >
                      <FormLabel>{commonProps(field, form).label}</FormLabel>
                      <Select
                        {...field}
                        width="100%"
                        {...commonProps(field, form)}
                        value={field.value}
                        onChange={(value) =>
                          form.setFieldValue(field.name, value.value)
                        }
                        options={titleOptions}
                      />
                      <FormErrorMessage>
                        {commonProps(field, form).errorMessage}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Box h={spacing} w={4} />

                <Flex direction={["column", "row"]}>
                  <Field name="firstName">
                    {({ field, form }) => (
                      <FormControl
                        flex={1}
                        isInvalid={commonProps(field, form).isInvalid}
                      >
                        <FormLabel>{commonProps(field, form).label}</FormLabel>
                        <Input {...field} {...commonProps(field, form)} />
                        <FormErrorMessage>
                          {commonProps(field, form).errorMessage}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>

                  <Box h={spacing} w={4} />

                  <Field name="lastName">
                    {({ field, form }) => (
                      <FormControl
                        flex={1}
                        isInvalid={commonProps(field, form).isInvalid}
                      >
                        <FormLabel>{commonProps(field, form).label}</FormLabel>
                        <Input {...field} {...commonProps(field, form)} />
                        <FormErrorMessage>
                          {commonProps(field, form).errorMessage}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                </Flex>
              </Flex>

              <Flex direction={["column", "column", "row"]}>
                <Field name="phone">
                  {({ field, form }) => {
                    return (
                      <FormControl
                        flex={1}
                        isInvalid={commonProps(field, form).isInvalid}
                      >
                        <FormLabel>{commonProps(field, form).label}</FormLabel>
                        <FlagPhoneInput
                          {...field}
                          {...commonProps(field, form)}
                          country={countryCode.toLowerCase()}
                          value={field.value}
                          onChange={(value) => {
                            form.setFieldValue(field.name, value);

                            // if (!form.touched.preferredComms) {
                            //   form.setFieldValue("preferredComms", {
                            //     ...form.values.preferredComms,
                            //     number: value,
                            //   });
                            // }
                            form.setFieldValue("preferredComms", {
                              channel: "whatsapp",
                              number: value,
                            });
                          }}
                        />
                        <FormErrorMessage>
                          {commonProps(field, form).errorMessage}
                        </FormErrorMessage>
                      </FormControl>
                    );
                  }}
                </Field>

                <Box boxSize={spacing} />

                <Field
                  name="preferredComms"
                  render={({ field, form }) => {
                    // let realValue = {
                    //   channel: field.value.channel,
                    //   number: field.value.number || form.values.phone,
                    // };
                    // if (field.value.phone && !field.value.number) {
                    //   form.setFieldValue(field.name, field.value.phone);
                    // }
                    return (
                      <FormControl
                        flex={1}
                        isInvalid={commonProps(field, form).isInvalid}
                      >
                        <FormLabel>{commonProps(field, form).label}</FormLabel>
                        {/* <QuickSelect
                        // value={realValue}
                        value={field.value}
                        onBlur={() => form.setFieldTouched(field.name, true)}
                        onChange={({ channel = "whatsapp", number }) => {
                          if (isPossibleNumber(number, countryCode)) {
                            const num = parseNumber(number, countryCode);
                            const whatsAppPhone = num.number.replace("+", "");
                            form.setFieldValue(field.name, {
                              channel,
                              number: whatsAppPhone,
                            });
                          } else form.setFieldValue(field.name, "");
                        }}
                        {...commonProps(field, form)}
                      /> */}
                        <FlagPhoneInput
                          {...field}
                          {...commonProps(field, form)}
                          country={countryCode.toLowerCase()}
                          value={field.value.number}
                          onChange={(value) => {
                            form.setFieldValue(field.name, {
                              channel: "whatsapp",
                              number: value,
                            });
                          }}
                        />
                        <FormErrorMessage>
                          {commonProps(field, form).errorMessage}
                        </FormErrorMessage>
                      </FormControl>
                    );
                  }}
                />
              </Flex>

              <Field name="email">
                {({ field, form }) => (
                  <FormControl
                    flex={1}
                    isInvalid={commonProps(field, form).isInvalid}
                  >
                    <FormLabel>{commonProps(field, form).label}</FormLabel>
                    <Input
                      type="email"
                      {...field}
                      {...commonProps(field, form)}
                    />
                    <FormErrorMessage>
                      {commonProps(field, form).errorMessage}
                    </FormErrorMessage>
                  </FormControl>
                )}
              </Field>

              <Field name="medium">
                {({ field, form }) => (
                  <FormControl
                    flex={1}
                    isInvalid={commonProps(field, form).isInvalid}
                  >
                    <FormLabel>{commonProps(field, form).label}</FormLabel>
                    <Select
                      {...field}
                      {...commonProps(field, form)}
                      value={field.value}
                      onChange={(value) =>
                        form.setFieldValue(field.name, value.value)
                      }
                      options={mediumOptions}
                      isSearchable={true}
                    />
                    <FormErrorMessage>
                      {commonProps(field, form).errorMessage}
                    </FormErrorMessage>
                  </FormControl>
                )}
              </Field>
            </Stack>

            {/* <Button
              mt={[6, 8]}
              colorScheme="blue"
              type="submit"
              isFullWidth
              fontSize="xl"
              rightIcon={<ChevronRightIcon />}
              isLoading={loading}
              loadingText={loadingText}
              size="lg"
            >
              Select lesson plan
            </Button> */}
            <CTAButtons
              onBackClick={onBackClick}
              submitText="Complete application"
              loading={loading}
            />
          </form>
        );
      }}
    </Formik>
  );
}

export default observer(ParentForm);
